var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("marketing-campaign-details-loader")
    : _c(
        "div",
        { staticClass: "container-fluid", attrs: { id: "agents-container" } },
        [
          _c(
            "b-row",
            {
              staticClass: "justify-content-center px-md-4",
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm.campaignDetails.status === "cancelled"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "marketing-campaign top-notification p-1 text-center fixed-top text-white side-right bg-danger",
                          staticStyle: { "z-index": "1" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("campaigns.messages.campaignCancelled")
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("page-header", {
                    attrs: {
                      title: _vm.create
                        ? _vm.$t("campaigns.actions.createACampaign")
                        : _vm.campaignDetails.name,
                      "show-back-button": "",
                      "static-back-route": "marketing-campaigns",
                      size: "col-8",
                      "container-class": "no-gutters",
                      "title-class": "client-name-header",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "inlinebuttons",
                        fn: function () {
                          return [
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "d-flex flex-row justify-content-end",
                              },
                              [
                                _vm.showCancelButton
                                  ? _c(
                                      "simple-button",
                                      {
                                        attrs: {
                                          "class-name":
                                            "d-xl-inline d-none text-danger bold btn-sm bs-0",
                                          loading: _vm.canceling,
                                          type: "transparent",
                                        },
                                        on: {
                                          click: _vm.showCancelCampaignModal,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "campaigns.actions.cancelCampaign"
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.create || _vm.editable
                                  ? _c("simple-button", {
                                      attrs: {
                                        "class-name":
                                          "d-xl-inline d-none btn-sm",
                                        text: _vm.$t(
                                          "global.actions.saveChanges"
                                        ),
                                        disabled: !_vm.canSave,
                                      },
                                      on: {
                                        click: _vm.showCreateCampaignModal,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.create || _vm.editable || _vm.showCancelButton
                              ? _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "d-flex d-xl-none",
                                    attrs: {
                                      variant: "transparent",
                                      "toggle-class":
                                        "text-gray position-static",
                                      "no-caret": "",
                                      right: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("more_vert")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3144653110
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _vm.create || _vm.editable
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            staticClass: "text-center",
                                            attrs: { disabled: !_vm.canSave },
                                            on: {
                                              click:
                                                _vm.showCreateCampaignModal,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "global.actions.saveChanges"
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showCancelButton
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            staticClass: "text-center",
                                            on: {
                                              click:
                                                _vm.showCancelCampaignModal,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "campaigns.actions.cancelCampaign"
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass:
                        "bg-clear-gray d-block mb-3 px-4 py-1 text-center",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("campaigns.messages.create.0")) +
                          "\n        "
                      ),
                      _c("b", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("campaigns.messages.create.1")) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("campaigns.messages.create.2")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("marketing-campaign-criteria", {
                    attrs: { name: _vm.$t("global.words.to") },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "b-row",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("campaigns.campaignName")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9", xl: "6" } },
                                  [
                                    _c("material-input", {
                                      attrs: {
                                        placeholder:
                                          "" + _vm.$t("account.name"),
                                        disabled: !_vm.editable,
                                        label: _vm.$t("account.name"),
                                        "hidden-label": "",
                                      },
                                      model: {
                                        value: _vm.campaignDetails.name,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.campaignDetails,
                                            "name",
                                            $$v
                                          )
                                        },
                                        expression: "campaignDetails.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "align-items-center" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "campaigns.actions.selectAList"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9", xl: "6" } },
                                  [
                                    _c(
                                      "material-input",
                                      {
                                        attrs: { disabled: !_vm.editable },
                                        model: {
                                          value: _vm.campaignDetails.listId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.campaignDetails,
                                              "listId",
                                              $$v
                                            )
                                          },
                                          expression: "campaignDetails.listId",
                                        },
                                      },
                                      [
                                        _c("select2", {
                                          attrs: {
                                            name: "list",
                                            options: _vm.select2Options("list"),
                                            data: _vm.LISTS,
                                            items: _vm.LISTS,
                                            "format-data": _vm.formatData,
                                            value: _vm.campaignDetails.listId,
                                          },
                                          on: { change: _vm.handleListChange },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.editable
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "clickable text-uppercase font-sm bold text-primary",
                                        attrs: { to: _vm.goAddList },
                                      },
                                      [
                                        _c("icon", { attrs: { name: "plus" } }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("global.words.create")
                                            ) +
                                            "\n            "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-2 mb-lg-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "campaigns.actions.selectASegment"
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                        _c("span", { staticClass: "small" }, [
                                          _vm._v(
                                            "\n                  (" +
                                              _vm._s(
                                                _vm.$t("global.words.optional")
                                              ) +
                                              ")\n                "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9", xl: "6" } },
                                  [
                                    _c(
                                      "material-input",
                                      {
                                        attrs: {
                                          disabled: _vm.segmentDisabled,
                                        },
                                      },
                                      [
                                        _c("select2", {
                                          attrs: {
                                            name: "segment",
                                            options:
                                              _vm.select2Options("segment"),
                                            data: _vm.currentList.segments,
                                            items: _vm.currentList.segments,
                                            "format-data": _vm.formatData,
                                            value:
                                              _vm.campaignDetails.segmentId,
                                          },
                                          on: {
                                            change: function (item) {
                                              return (_vm.campaignDetails.segmentId =
                                                item.id)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("marketing-campaign-criteria", {
                    attrs: { name: _vm.$t("global.words.from") },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "b-row",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("campaigns.yourName")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9", xl: "6" } },
                                  [
                                    _c("material-input", {
                                      attrs: {
                                        placeholder:
                                          "" + _vm.$t("account.name"),
                                        disabled: !_vm.editable,
                                        label: _vm.$t("account.name"),
                                        "hidden-label": "",
                                      },
                                      model: {
                                        value: _vm.campaignDetails.fromName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.campaignDetails,
                                            "fromName",
                                            $$v
                                          )
                                        },
                                        expression: "campaignDetails.fromName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "align-items-center" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "global.doorr.emailAddress"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9", xl: "6" } },
                                  [
                                    _c("marketing-emails-select", {
                                      attrs: {
                                        id: "select-email",
                                        value: _vm.campaignDetails.email.id,
                                        emails: _vm.GET_MARKETING_EMAILS,
                                        "space-classes": "col-12 px-0",
                                        name: "value",
                                        multiple: false,
                                        "show-label": false,
                                        disabled: !_vm.editable,
                                        "select-options":
                                          _vm.select2Options("email"),
                                        required: "",
                                      },
                                      on: { change: _vm.handleEmailChange },
                                    }),
                                    _vm._v(" "),
                                    _vm.showVerifyEmail
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "p-0",
                                            attrs: { variant: "transparent" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showAddEmailModal(
                                                  false
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-light-gray m-0",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "global.words.click",
                                                        1
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "clickable text-primary",
                                                    attrs: {
                                                      id: "verify-existing-email",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "global.words.here"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "campaigns.messages.toConfirmVerification"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.editable
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "text-uppercase font-sm bold text-primary clickable",
                                        attrs: { id: "create-email" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showAddEmailModal(true)
                                          },
                                        },
                                      },
                                      [
                                        _c("icon", { attrs: { name: "plus" } }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("global.words.create")
                                            ) +
                                            "\n            "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("marketing-campaign-criteria", {
                    attrs: { name: _vm.$t("global.words.subject") },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "b-row",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("global.words.subject")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9", xl: "6" } },
                                  [
                                    _c("material-input", {
                                      attrs: {
                                        placeholder:
                                          "" + _vm.$t("global.words.subject"),
                                        disabled: !_vm.editable,
                                        label: _vm.$t("global.words.subject"),
                                        "hidden-label": "",
                                      },
                                      model: {
                                        value: _vm.campaignDetails.subject,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.campaignDetails,
                                            "subject",
                                            $$v
                                          )
                                        },
                                        expression: "campaignDetails.subject",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("campaigns.previewText")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9", xl: "6" } },
                                  [
                                    _c("material-input", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "campaigns.previewText"
                                        ),
                                        disabled: !_vm.editable,
                                        label: _vm.$t("campaigns.previewText"),
                                        "hidden-label": "",
                                      },
                                      model: {
                                        value: _vm.campaignDetails.previewText,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.campaignDetails,
                                            "previewText",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "campaignDetails.previewText",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("marketing-campaign-criteria", {
                    attrs: { name: _vm.$t("global.words.design") },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$tc(
                                                "campaigns.emailTemplate",
                                                1
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-items-start",
                                    attrs: { cols: "9", xl: "6" },
                                  },
                                  [
                                    _c("marketing-campaign-template-select", {
                                      attrs: {
                                        "show-template": _vm.showTemplate,
                                        "campaign-details": _vm.campaignDetails,
                                        create: _vm.create,
                                        editable: _vm.editable,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("marketing-campaign-criteria", {
                    attrs: { name: _vm.$t("global.words.delivery") },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-center",
                                    attrs: { cols: "12", xl: "5", md: "4" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold text-light-gray font-sm mb-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("campaigns.deliveryTime")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-column justify-content-end",
                                    attrs: { cols: "9", xl: "6" },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "material-input",
                                              {
                                                staticClass:
                                                  "form-group-material-no-label",
                                                attrs: {
                                                  disabled: !_vm.editable,
                                                  "validator-context": _vm.$v,
                                                },
                                                model: {
                                                  value:
                                                    _vm.campaignDetails
                                                      .scheduledDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.campaignDetails,
                                                      "scheduledDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "campaignDetails.scheduledDate",
                                                },
                                              },
                                              [
                                                _c("datepicker-input", {
                                                  attrs: {
                                                    id: "date-input",
                                                    name: "scheduledDate",
                                                    placeholder: "YYYY-MM-DD",
                                                    "show-calendar": false,
                                                    "future-date": "",
                                                    "class-name":
                                                      "required\n                    valid-date future-date",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.campaignDetails
                                                        .scheduledDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.campaignDetails,
                                                        "scheduledDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "campaignDetails.scheduledDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _c(
                                              "material-input",
                                              {
                                                staticClass:
                                                  "form-group-material-no-label",
                                                attrs: {
                                                  disabled: !_vm.editable,
                                                  "label-for": "time-input",
                                                  label: _vm.$t(
                                                    "campaigns.deliveryTime"
                                                  ),
                                                  "hidden-label": "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.campaignDetails
                                                      .scheduledTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.campaignDetails,
                                                      "scheduledTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "campaignDetails.scheduledTime",
                                                },
                                              },
                                              [
                                                _c("time-input", {
                                                  attrs: {
                                                    id: "time-input",
                                                    "default-value": "",
                                                    "drop-direction": "up",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.campaignDetails
                                                        .scheduledTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.campaignDetails,
                                                        "scheduledTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "campaignDetails.scheduledTime",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("create-email-modal", {
            ref: "addEmailModal",
            attrs: {
              "force-show-verify": _vm.showVerifyEmail && !_vm.createEmail,
              "force-email-to-verify": _vm.campaignDetails.email,
            },
            on: {
              "close-modal": function ($event) {
                return _vm.handleEmailChange(_vm.campaignDetails.email.emailId)
              },
            },
          }),
          _vm._v(" "),
          _c("create-campaign-modal", {
            ref: "createCampaignModal",
            attrs: {
              create: _vm.create,
              "scheduled-date": _vm.campaignDetails.scheduledDate,
              "scheduled-time": _vm.campaignDetails.scheduledTime,
              saving: _vm.saving,
              "saving-succeeded": _vm.savingSucceeded,
            },
            on: { submit: _vm.handleSubmit },
          }),
          _vm._v(" "),
          _c("cancel-campaign-modal", {
            ref: "cancelCampaignModal",
            attrs: { canceling: _vm.canceling },
            on: { submit: _vm.handleCancel },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }